import { getToken, onMessage, MessagePayload } from "firebase/messaging";

import { saveNotificationToken } from "@services/authService";
import { messaging } from "./firebase";

export async function registerWebFcmToken(accessToken?: string) {
	if (!accessToken) return;

	const perm = await Notification.requestPermission();
	if (perm !== "granted") return;

	const token = await getToken(messaging, {
		vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY!,
	});

	if (!token) return;

	// send to backend
	await saveNotificationToken({
		notification_token: token,
		device_type: "web",
	});

	return token;
}

export function listenForegroundMessages(
	onReceive: (p: MessagePayload) => void,
) {
	return onMessage(messaging, onReceive);
}
